import React from 'react';
import { Accordion, Box } from '@rsos/components/capstone/base';
import { AccordionContainer, StartChatButton } from './TF911.styles';
import TF911StartChatMessages from './TF911StartChatMessages';
import usePreconfiguredMessages from './usePreconfiguredMessages';

const OFFSET_HEIGHT = 92; // height of the header above the start button

const TF911StartChatAccordion = ({
  isCreatingConversation,
  onClickShowAccordion,
  onStartConversation,
  showPreconfiguredMessages,
  showStartChat,
}) => {
  const preconfiguredMessages = usePreconfiguredMessages();

  const handleDefaultStartClick = () => {
    onStartConversation(preconfiguredMessages[0]);
  };

  return (
    <Box mt="8px" width="100%" height="100%">
      <AccordionContainer showBorder={showPreconfiguredMessages}>
        <Accordion
          btnDisabled={isCreatingConversation}
          btnSize="med"
          btnPx="10px"
          callback={onClickShowAccordion}
          content={
            <TF911StartChatMessages
              isCreatingConversation={isCreatingConversation}
              preconfiguredMessages={preconfiguredMessages}
              onSendMessageClick={onStartConversation}
            />
          }
          header={
            <Box
              alignSelf="center"
              horizontal
              width="100%"
              borderRadius="0 0 5px 5px"
            >
              <StartChatButton
                btnType="tertiary"
                disabled={isCreatingConversation}
                isLoadingProp={isCreatingConversation}
                noMargin
                onClick={handleDefaultStartClick}
                size="med"
                grow
                width="100%"
              >
                Start Chat
              </StartChatButton>
            </Box>
          }
          headerIcon="chevron"
          headerPadding="0 12px"
          isOpened={showPreconfiguredMessages}
          interactionType="button"
          noBorder
          height={`calc(100% - ${OFFSET_HEIGHT}px)`}
          padding="0"
          width="100%"
        />
      </AccordionContainer>
    </Box>
  );
};

export default TF911StartChatAccordion;
